var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDirections(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    stroke: "#000",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.752 15.928L16.597 5.238a.871.871 0 00-1.195 0L4.248 15.927A.793.793 0 004 16.5c0 .215.089.42.248.573l11.154 10.69A.86.86 0 0016 28a.86.86 0 00.597-.238l11.155-10.69A.795.795 0 0028 16.5c0-.215-.09-.42-.248-.572zm-7.823-.288l-2.183 2.092a.858.858 0 01-.598.238.86.86 0 01-.597-.238.786.786 0 010-1.145l.747-.716h-3.786v4.32c0 .447-.379.81-.846.81-.466 0-.845-.363-.845-.81v-5.13c0-.447.379-.81.845-.81h4.62l-.909-.87a.786.786 0 010-1.145.871.871 0 011.195 0l2.357 2.259c.33.316.33.829 0 1.145z",
    fill: "#000"
  })));
}

export default SvgDirections;